import { z } from 'zod';
import { baseEmailDTOSchema } from './email/base-email-dto';
import { decommissionEmailSchemas } from './email/decommission-emails';
import { fimEmailSchemas } from './email/fim-emails';
import { identityEmailSchemas } from './email/identity-emails';
import { planningEmailSchemas } from './email/planning-emails';
import { trialEmailSchemas } from './email/trial-emails';
import { workIntegrationEmailSchemas } from './email/work-integration-emails';

export { baseEmailDTOSchema };

export const sendEmailDTOSchema = z.discriminatedUnion('template', [
  ...identityEmailSchemas,
  ...trialEmailSchemas,
  ...fimEmailSchemas,
  ...workIntegrationEmailSchemas,
  ...planningEmailSchemas,
  ...decommissionEmailSchemas,
]);

// Backward compatibility: email messages enqueued before the jira_reauth →
// work_integration_reauth rename still carry the legacy template name. Rewrite it to the
// current template before validation so in-flight emails still render during the
// transition window. Remove once the send-email queue has drained.
export const LEGACY_EMAIL_TEMPLATE_ALIASES: Record<string, string> = {
  jira_reauth_notification: 'work_integration_reauth_notification',
};

export const normalizeEmailTemplate = (template: string): string =>
  LEGACY_EMAIL_TEMPLATE_ALIASES[template] ?? template;
